<template>
  <div class="vue-tooltip" v-click-outside="hideTooltip">
    <div
      class="vue-tooltip__target"
      @mouseenter="trigger === 'hover' && showTooltip()"
      @mouseleave="trigger === 'hover' && hideTooltip()"
      @click="trigger === 'click' && toggleTooltip()"
    >
      <slot name="target"></slot>
    </div>
    <div
      v-if="isVisible"
      class="vue-tooltip__content"
      :class="[`vue-tooltip__content--${position}`, { 'vue-tooltip__content--custom': customPosition }]"
      :style="customPositionStyle"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueTooltip",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: "top",
      validator(value) {
        return [
          "top",
          "top-left",
          "top-right",
          "right",
          "bottom",
          "bottom-left",
          "bottom-right",
          "left",
        ].includes(value);
      },
    },
    trigger: {
      type: String,
      default: "hover",
      validator(value) {
        return ["hover", "click"].includes(value);
      },
    },
    customPosition: {
      type: Object,
      default: null,
      validator(value) {
        if (!value) return true;
        const validKeys = ['top', 'left', 'bottom', 'right', "transform"];
        return Object.keys(value).every(key => validKeys.includes(key));
      }
    }
  },
  data() {
    return {
      isVisible: false,
    };
  },
  emits: ["show", "hide"],
  computed: {
    customPositionStyle() {
      if (!this.customPosition) return {};
      return {
        position: 'absolute',
        ...this.customPosition
      };
    }
  },
  methods: {
    showTooltip() {
      if (this.disabled) return;
      this.isVisible = true;
      this.$emit("show");
    },
    hideTooltip() {
      if (this.disabled) return;
      this.isVisible = false;
      this.$emit("hide");
    },
    toggleTooltip() {
      if (this.disabled) return;
      this.isVisible = !this.isVisible;
      if (this.isVisible) {
        this.$emit("show");
      } else {
        this.$emit("hide");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.vue-tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;

  &__target {
    display: flex;
  }

  &__content {
    position: absolute;
    z-index: 100;

    &--top {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 6px;
    }

    &--top-left {
      bottom: 100%;
      left: 0;
      margin-bottom: 6px;
    }

    &--top-right {
      bottom: 100%;
      right: 0;
      margin-bottom: 6px;
    }

    &--right {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      margin-left: 6px;
    }

    &--bottom {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 6px;
    }

    &--bottom-left {
      top: 100%;
      left: 0;
      margin-top: 6px;
    }

    &--bottom-right {
      top: 100%;
      right: -20px;
      margin-top: 6px;
    }

    &--left {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      margin-right: 6px;
    }

    &--custom {
      margin: 0;
    }
  }
}
</style>